export const SOCIAL_CONNECT_HREF = '/home/integrations?category=social';

export const MESSAGING_CONNECT_HREF = '/home/integrations?category=messaging';

export const COMMERCE_CONNECT_HREF = '/home/integrations?category=commerce';

export const ADS_CONNECT_HREF = '/home/integrations?category=ads';

export const SCHEDULING_CONNECT_HREF = '/home/integrations?category=scheduling';

